/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Census = {
    properties: {
        id: {
    type: 'number',
},
        census: {
    type: 'number',
    isRequired: true,
},
    },
};